import { render } from "./ResetPassword.vue?vue&type=template&id=5bac8daf&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=5bac8daf&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bac8daf"]])

export default __exports__